import { createAsyncThunk } from "@reduxjs/toolkit";
import { PdfClient } from "../../../api/api";
import { AsyncOperationHandler } from '../../../utilities/platform-helpers/api-helper';
import { pdfClient } from "../../api-clients";

export const getPdfById = createAsyncThunk('pdfs/getPdfById', (urlId: string) => {
    return AsyncOperationHandler((client) => (client as PdfClient).getPdfByUrlId(urlId), pdfClient);
  });